<template>
  <div>
    <v-container fluid class="pa-0">
      <!-- <material-card icon="mdi-clipboard-text" inline title="View Vehicle Details"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize text-nowrap">
                  <span>Vendor/Vehicle Details - Transport</span>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="9" class="text-right">
            <v-card-actions class="d-block">
              <router-link :to="{ name: 'VendorAdd', params: {} }" title="Create Vendor Details">
                <v-btn size="large" class="create-vehicle-button" elevation="1" color="primary">
                  <v-icon left>mdi-plus</v-icon>
                  Add New Vendor/Vehicle Details
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <div
            class="v-card-title"
            :class="{
              'text-h6': $vuetify.breakpoint.smAndUp,
              'text-subtitle-1': $vuetify.breakpoint.xs
            }"
          >
            {{ `Total Added Vendor: ${totalVendorCounts}` }}
          </div>

        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table
          :headers="headers"
          :items="vendorList"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td>{{ item.srNo}}</td>
              <td>{{ item.ownedBy || '-' }}</td>
              <td>{{ item.ownerName || '-' }}</td>
              <td>{{ item.ownersMobileNumber || '-' }} <v-icon color="success" v-if="item.ownersMobileNumber" x-small>mdi-check-decagram</v-icon></td>
              <td>{{ item.numberOfBuses }}</td>
              <td>{{ item.numberOfDrivers || '-' }}</td>
              <td >
                <v-menu
                  v-model="isVisibleVehicleDocs[index]"
                  :close-on-content-click="false"
                  offset-y
                 :disabled="!item.isActive"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on">Vehicle Documents</a>
                  </template>
                  <v-list>
                    <v-list-item-group>
                      <template v-for="(doc, index) in item.transportVendorBuses">
                        <v-list-item
                          v-if="doc.isActive"
                          :key="index"
                          @click="onVehicleDocument(doc, item.id)"
                          :class="{ 'recent-item': doc.rcExpiryDetails.isExpired }"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="ml-5 mr-5">Vehicle {{ index + 1}} - Doc
                              <v-tooltip v-if="doc.rcExpiryDetails.isExpired" right color="#E65050">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="ml-5" v-bind="attrs" v-on="on">mdi-information</v-icon>
                                </template>
                                <span
                                class="red-tooltip"
                                 >
                                {{ doc.rcExpiryDetails.sentence }}
                                </span>

                              </v-tooltip>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
                <br/>
                <v-menu
                  v-model="isVisibleDriverDocs[index]"
                  :close-on-content-click="false"
                  offset-y
                  :disabled="!item.isActive"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on" >Driver's Documents</a>
                  </template>
                  <v-list>
                    <v-list-item-group>
                      <template v-for="(doc, index) in item.transportVendorDrivers">
                        <v-list-item
                          v-if="doc.isActive"
                          :key="index"
                          @click="onDriverDocument(doc, item.id)"
                          :class="{ 'recent-item': doc.licenseExpiryDetails.isExpired }"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="ml-5 mr-5">Driver {{ index + 1}} - Doc
                            <v-tooltip v-if="doc.licenseExpiryDetails.isExpired" right color="#E65050">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="ml-5" v-bind="attrs" v-on="on">mdi-information</v-icon>
                                </template>
                                <span class="red-tooltip">{{ doc.licenseExpiryDetails.sentence }}</span>
                              </v-tooltip>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </td>
              <td>{{ formatDate(item.updatedAt) }}</td>
              <td class="text-center">
                 <span class="viewiconsvendor">
                  <v-icon @click="openInNewTab(item)">mdi-eye</v-icon>
                </span>
                <span class="viewiconsvendor">
                <router-link  v-if="item.isActive"    :to="{ name: 'VendorEdit', params: { vendorID: item.id, isEdit: true, deactivatingVendor: false } }">
                  <v-icon>mdi-square-edit-outline</v-icon>
                  <!-- <v-btn class="px-2 ml-1 ma-1" color="success" x-small outlined>
                    Edit
                  </v-btn> -->
                </router-link>
                </span>
                <br/>

                <v-btn  v-if="item.isActive" class="px-2 mb-2" color="#f10000" @click="onDeactivateVendor(item)" x-small style="color: white;"  >
                  Deactivate Owner
                  <!-- <v-icon>mdi-delete</v-icon> -->
                </v-btn>
                <v-btn  v-else class="px-2 mb-2" color="#09ad19" @click="onActivateVendor(item)"    x-small style="color: white;"  >
                  Activate Owner
                  <!-- <v-icon>mdi-delete</v-icon> -->
                </v-btn>

                <!-- Uncomment and modify as needed -->
                <!-- <v-btn color="error" min-width="0" small class="px-2 ml-1 ma-1" v-if="item.isActive === true" @click.prevent="activeDeactive(item.id)">
                    <v-icon small> mdi-delete</v-icon>
                  </v-btn>
                  <v-btn class="px-2 ml-1 ma-1" color="accent" min-width="0" small v-if="item.isActive !== true" @click.prevent="Reactive(item.id)">
                    <v-icon small> mdi-restore</v-icon>
                  </v-btn> -->
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Vendors Found <br/>Click on Add New Vendor/Vehicle Details CTA</v-card-subtitle>
          </template>
        </v-data-table>
      </v-card>
      <loading-icon :value="isLoading" />
    </v-container>
    <div class="modal" :class="{ 'is-active': enableDocumentModal }">
      <div class="modal-background"></div>

      <form class="modal-card" @submit.prevent="ShowDocuments()">
        <header class="modal-card-head" style="margin-top:90px;">
          <p class="modal-card-title mb-0"><strong>View Documents</strong></p>
          <button class="delete" type="button" @click="this.toggleDocumentModal"></button>
        </header>
        <v-container class="modal-card-body" fluid>
          <v-row>
            <v-col cols="12" sm="6" md="4" v-for="field in fileFields" :key="field.field">
              <v-card class="pa-3" outlined>
                <v-layout column align-center class="imagevvendowviewuploadpadd">

                  <v-flex class="imagevvenderdownload">
                    <div class="file imagevvendowviewupload" v-if="findS3Url(field.field)">
                      <img :src="getS3Url(field.field)" :alt="field.field" width="150px" height="150px" />
                    </div>
                    <div v-else>
                      <span class="tag is-primary">No photo available</span>
                    </div>
                  </v-flex>
                  <v-flex class="imagevvenderdownload-buttom" >
                    <span  style="font-size: 10px">{{ field.label  }}</span>
                    <v-icon class="ml-2" v-if="findS3Url(field.field)" @click.prevent="downloadDocuments(getS3Url(field.field))" left>mdi-download</v-icon>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </form>
    </div>
  </div>
</template>

<script>
// import VCardComponent from '@/components/template/VCardComponent'
// import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
import moment from 'moment'
import stores from '@/stores'

export default {
  name: 'Vendor',
  components: {
    // MaterialCard
    //  VCardComponent
  },
  data () {
    return {
      isVisibleVehicleDocs: {},
      isVisibleDriverDocs: {},
      isLoading: false,
      loadingComponent: null,
      academicYears: [],
      academicYearID: '',
      stages: [],
      inProgress: false,
      franchiseeArr: [],
      franchiseeID: null,
      enableDocumentModal: false,
      UserType: '',
      vendorDocuments: [],
      status: '',
      vendorList: [],
      totalVendorCounts: 0,
      currentPage: 1,
      headers: [
        { text: 'Sr No.', value: 'srNo', sortable: false },
        { text: 'Owned By', value: 'companyName', sortable: false },
        { text: 'Owner Name', value: 'vendorName', sortable: false },
        { text: 'Contact No', value: 'contactNo', sortable: false },
        { text: 'No. of Vehicles', value: 'numberOfVehicles', sortable: false },
        { text: 'No. of Drivers', value: 'numberOfDrivers', sortable: false },
        { text: 'Vendor Docs', value: 'numberOfDrivers', sortable: false },
        { text: 'Last Modified On', value: 'lastModifiedOn', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      docsheaders: [{ text: 'Vendor Docs', value: 'Vehicle_Documents', sortable: true }],
      fileFields: [
        { field: 'driverPhoto', label: 'Driver' },
        { field: 'busFrontViewPhoto', label: 'Bus Front View' },
        { field: 'busSideViewPhoto', label: 'Bus Side View' },
        { field: 'busRearViewPhoto', label: 'Bus Rear View' },
        { field: 'busInteriorViewPhoto', label: 'Bus Interior View' },
        { field: 'rcBookPhoto', label: 'RC Book' }
      ]
    }
  },
  async created () {
    await this.getYear()
    // await this.getFranchiseeList()
    if (this.franchisee.id) {
      this.franchiseeID = this.franchisee.id
    }
  },
  mounted: async function () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.onFranchiseeChange()
      }
    }
    // academicYear: async function () {
    //   await this.onFranchiseeChange()
    // }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  methods: {
    formatDate (rawDate) {
      return moment(rawDate).format('DD/MM/YYYY')
    },
    openInNewTab (item) {
      const url = this.$router.resolve({
        name: 'VendorViewOnly',
        params: {
          vendorID: item.id
        }
      }).href
      window.open(url, '_blank')
    },
    isDateInExpiry (dateString, type, key, isActive) {
      const today = moment().startOf('day')
      const docDate = moment(dateString, 'YYYY-MM-DD')
      const differenceInDays = docDate.diff(today, 'days')
      const autoDeactivationDate = docDate.clone().subtract(5, 'days')
      const differenceInDeactivationDays = autoDeactivationDate.diff(today, 'days')
      const within60Days = docDate.isBefore(today.clone().add(60, 'days'))
      const deactivationDate = autoDeactivationDate.format('DD/MM/YYYY')
      let isExpired = false
      let sentence = ''

      if (within60Days) {
        // Future expiry
        if (differenceInDays > 0) {
          let diffIncludingEventDay = docDate.diff(today, 'days') + 1
          let diffDeactivationDay = diffIncludingEventDay - 5

          if (diffDeactivationDay <= 0) {
            sentence = `${type} expiring in ${Math.abs(diffIncludingEventDay)} days.`
            sentence += isActive
              ? (isActive && diffDeactivationDay === 0
                ? `The ${key} will be deactivated today.`
                : `The ${key} will be deactivated.`)
              : `The ${key} is already deactivated.`
          } else if (diffDeactivationDay === 1) {
            sentence = `${type} expiring in ${Math.abs(diffIncludingEventDay)} days.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated in 1 day.`
              : ` The ${key} is already deactivated.`
          } else if (diffIncludingEventDay === 1) {
            sentence = `${type} expiring in 1 day.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated.`
              : ` The ${key} was auto deactivated on ${deactivationDate}.`
          } else if (diffIncludingEventDay === 5) {
            sentence = `${type} expiring in 5 days.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated in 5 days.`
              : ` The ${key} was auto deactivated on ${deactivationDate}.`
          } else if (diffIncludingEventDay < 5) {
            sentence = `${type} expiring in ${Math.abs(diffIncludingEventDay)} days.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated.`
              : ` The ${key} was auto deactivated on ${deactivationDate}.`
          } else {
            sentence = `${type} expiring in ${diffIncludingEventDay} days.`
            sentence += isActive
              ? `The ${key} will be auto deactivated on ${deactivationDate}.`
              : `The ${key} is already deactivated.`
          }
        } else if (differenceInDays === 0) {
          if (docDate.isSame(today.clone().add(1, 'days'), 'day')) {
            // If the date is tomorrow
            sentence = `${type} expiring in 1 day.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated soon.`
              : ` The ${key} is already deactivated.`
          } else if (today.isSame(autoDeactivationDate, 'day')) {
            sentence = `${type} expiring today.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated today.`
              : ` The ${key} is already deactivated.`
          } else {
            sentence = `${type} expired today. The ${key} was auto deactivated on ${deactivationDate}.`
          }
        } else {
          const expiredDaysAgo = Math.abs(differenceInDays)
          if (expiredDaysAgo === 1) {
            sentence = `${type} expired ${expiredDaysAgo} day ago. The ${key} was auto deactivated on ${deactivationDate}.`
          } else if (expiredDaysAgo === 5) {
            sentence = `${type} expired ${expiredDaysAgo} days ago. The ${key} was auto deactivated on ${deactivationDate}.`
          } else {
            sentence = `${type} expired ${expiredDaysAgo} days ago. The ${key} was auto deactivated on ${deactivationDate}.`
          }
        }
        isExpired = true
      }

      return {
        isExpired,
        differenceInDays,
        differenceInDeactivationDays,
        sentence
      }
    },
    onDeactivateVendor (item) {
      this.$router.push({ name: 'VendorEdit',
        params: {
          vendorID: item.id,
          isEdit: false,
          deactivatingVendor: true,
          activatingVendor: false
        } })
    },
    onActivateVendor (item) {
      this.$router.push({ name: 'VendorEdit',
        params: {
          vendorID: item.id,
          isEdit: false,
          deactivatingVendor: false,
          activatingVendor: true
        } })
    },
    onVehicleDocument (doc, vendorID) {
      this.isVisibleVehicleDocs = false
      const path = `vendors/${vendorID}/documents`
      const url = this.$router.resolve({ path, query: { id: doc.busID, documentType: 'Vehicle' } }).href
      window.open(url, '_blank')
    },
    onDriverDocument (doc, vendorID) {
      const path = `vendors/${vendorID}/documents`
      const url = this.$router.resolve({ path, query: { id: doc.driverID, documentType: 'Driver' } }).href
      window.open(url, '_blank')
    },
    findS3Url (field) {
      let isFound = this.vendorDocuments.find(i => i.field === field)
      if (isFound) return true
      return false
    },
    getS3Url (field) {
      return this.vendorDocuments.find(i => i.field === field).urlPath
    },
    deleteVendorBus (item) {
      if (Number(item.numberOfBuses) < 2) {
        this.errMsg('Cannot delete! Atleast one content is required!')
        return
      }
      let vendorName = item.vendorName
      this.$dialog.warning({
        title: `Bus ${item.busSequenceNumber}, Vendor: ${vendorName.length > 10 ? vendorName.slice(0, 10) + '...' : vendorName}`,
        text: 'Are you sure you want to delete this bus details?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.post(`${constants.API_URL}/api/transport/vendors/${item.transportVendorID}/delete`, {
                  id: item.transportVendorBusID
                })
                this.$dialog.info({
                  text: `Vendor Bus deleted successfully`,
                  title: 'Success'
                })
                this.getListing()
                // this.isLoading = false
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message

                return this.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },

    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee && this.franchisee.id) {
          this.franchiseeID = this.franchisee.id
        } else {
          let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
          this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        await this.getListing()
        this.inProgress = false
      }
    },
    getFranchiseeDataFromIndexDB: function () {
      let obj = stores.user.franchisee
      return obj
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    viewDocuments: async function (ID) {
      this.toggleDocumentModal()
      let response = await http.get(`${constants.API_URL}/api/transport/vendors/${ID}/documents`)
      this.vendorDocuments = response.data
    },
    downloadDocuments: function (url) {
      window.open(url)
    },
    toggleDocumentModal: function () {
      this.enableDocumentModal = !this.enableDocumentModal
    },
    getListing: async function () {
      this.vendorList = []
      this.totalVendorCounts = 0
      try {
        let getParam = {}
        if (!this.franchiseeID) {
          this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          getParam.franchiseeID = this.franchiseeID
        }
        // getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vendors`, {
          params: getParam
        })
        data.forEach(item => {
          item.transportVendorBuses = item.transportVendorBuses.map(bus => {
            const expiryDetails = this.isDateInExpiry(bus.rcBookExpiryDate, 'RC', 'Bus/Van', bus.isActive)
            return {
              ...bus,
              rcExpiryDetails: expiryDetails
            }
          })

          item.transportVendorDrivers = item.transportVendorDrivers.map(driver => {
            const expiryDetails = this.isDateInExpiry(driver.licenceExpiryDate, 'License', 'Driver', driver.isActive)
            return {
              ...driver,
              licenseExpiryDetails: expiryDetails
            }
          })
        })

        this.vendorList = data.map((item, index) => ({
          ...item,
          srNo: index + 1
        }))
        this.totalVendorCounts = this.vendorList.length
      } catch (e) {
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style >
.imagevvendowviewupload{
  width:100%
}
.imagevvendowviewupload img{
  max-width: 100%;
}
.imagevvendowviewuploadpadd{
  padding: 0px;
}

.imagevvenderdownload-buttom{
  padding-top: 8px;
  width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.imagevvenderdownload-buttom button{
  font-size: 18px!important;
    width: 22px;
    height: 22px;
    display: inline-block;
    margin: 0px!important;
}
.recent-item {
  background-color: red;
}
.red-tooltip {
  pointer-events: auto;
  background-color: '#E65050';
   color: '#fff',
}
.text-nowrap {
  white-space: nowrap;
}

.create-vehicle-button {
  margin-top: 20px; /* Adjust if needed */
}

.viewiconsvendor .v-icon{
  font-size: 20px;
  margin: 5px 10px;
    display: inline-block;
    width: 32px;
    border: 1px solid #ddd;
    padding: 2px 4px;
    border-radius: 5px;
}
</style>
